import { Component } from '@angular/core';


@Component({
  template: '',
  imports: []
})
export class EmptyComponent  {

}
